import React, { useCallback, useState } from 'react';
import _ from 'lodash';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import { wizardProps } from 'gw-portals-wizard-react';
import { withRouter } from 'react-router-dom';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import metadata from './ConfirmationPage.metadata.json5';
import messages from './ConfirmationPage.messages';
import styles from './ConfirmationPage.module.scss';
import { useDependencies } from 'gw-portals-dependency-react';
import { useAuthentication } from 'gw-digital-auth-react';
import {ModalNextProvider, Loader } from '@jutro/components';
import { messages as commonMessages } from 'gw-platform-translations';

function ConfirmationPage(props) {
    const { wizardData } = props;
    const { submissionVM } = wizardData;
    const changesAppliedForward = _.get(wizardData, 'changesAppliedForward');
    const canApplyChangesToFutureRenewal_EY = _.get(wizardData, 'canApplyChangesToFutureRenewal_EY');
    const canApplyChangesToFutureUnboundRenewal_EY = _.get(wizardData, 'canApplyChangesToFutureUnboundRenewal_EY');
    const isGateway = appConfig.persona === 'producer' || appConfig.persona === 'csr';
    const changesAppliedForwardText = isGateway
        ? messages.contactUnderwriterMessage
        : messages.contactAgentMessage;
    const { EndorsementService } = useDependencies('EndorsementService');
    const { authHeader } = useAuthentication();
    const [isLoading, setLoading] = useState(false);
    const overrideProps = {
        pageHeaderTitle: {
            className: styles.confirmationLabel
        },
        policyChangeConfirmationMessage: {
            className: styles.inlineNotificationStyle,
            content: changesAppliedForward && changesAppliedForwardText
        },
        backToPolicyButtonId: {
            content: isGateway ? messages.backToPolicy : messages.backToHome,
            visible: !canApplyChangesToFutureRenewal_EY
        },
        backToPolicyRenewalButtonId: {
            visible: canApplyChangesToFutureRenewal_EY || canApplyChangesToFutureUnboundRenewal_EY
        },
        viewApplyRenewalButton: {
            visible: canApplyChangesToFutureRenewal_EY
        },
        applyChangesToFutureRenewal: {
            visible: canApplyChangesToFutureRenewal_EY
        },
        viewApplyToUnboundRenewalButton: {
            visible: canApplyChangesToFutureUnboundRenewal_EY
        },
        applyChangesToFutureUnboundRenewal: {
            visible: canApplyChangesToFutureUnboundRenewal_EY
        }
    };

    const goToPolicy = useCallback(() => {
        const { history } = props;
        const policyNumber = _.get(submissionVM.value, 'policyNumber');
        const redirectPath = isGateway ? `/policies/${policyNumber}/summary` : '/';
        history.push(redirectPath);
    }, [isGateway, props, submissionVM]);

    const goToEndorsement = useCallback(async () => {
        const { history } = props;
        const policyNumber = _.get(submissionVM.value, 'policyNumber');
        setLoading(true);
        const policyChangeData = await EndorsementService.applyChangesToFutureBoundRenewal(
            submissionVM.jobID.value,
            authHeader
        );
        setLoading(false);
        const redirectPath = `/change/${policyChangeData.jobID}/summary`;
        history.push({
            pathname: redirectPath,
            applyRenewalChanges: policyNumber
        });
    }, [props, submissionVM]);

    const goToRenewal = useCallback(async () => {
        const { history } = props;
        setLoading(true);
        const policyChangeData = await EndorsementService.applyChangesToFutureUnBoundRenewal(
            submissionVM.jobID.value,
            authHeader
        );
        setLoading(false);
        if (policyChangeData) {
            const redirectPath = `/renewal/${policyChangeData.nextRenewalNumber}/summary`;
            history.push({
                pathname: redirectPath,
                applyRenewalChanges: policyChangeData.nextRenewalNumber
            });
        }
    }, [props, submissionVM]);

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            goToPolicy: goToPolicy,
            goToEndorsement: goToEndorsement,
            goToRenewal: goToRenewal
        }
    };

    if (isLoading) {
        return <Loader loaded={!isLoading} />;
    }

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={submissionVM}
            overrideProps={overrideProps}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
}

ConfirmationPage.propTypes = wizardProps;
export default withRouter(ConfirmationPage);
